import React from 'react'
import '../../../base/Theme.css';
import './ChatMessage.css';

const ChatMessage = ({message}) => {
    return (
        <div key={message.id}>
            <p className="ChatMessageMessage">
                <span className="ChatMessageName">{message?.playerName + ": "}</span>{message?.message}
            </p>
        </div>
    );
}

export default ChatMessage;
